import React, { useState, useEffect } from 'react';
import { useMediaQuery } from 'usehooks-ts';
import Button from '../../../src/components/pages/ui/Button/Button';
import './CarDetailsChange.scss';

export default function CarDetailsChange({ fields }) {
  const isTablet = useMediaQuery('(max-width: 834px)');
  const isMobile = useMediaQuery('(max-width: 480px)');

  const getItemTitle = (item) => {
    let defaultText = '';

    if (item && item.fields) {
      return item.fields.title?.value || '';
    }

    return defaultText;
  };

  const getItemContent = (item) => {
    let defaultContent = [];

    if (item?.fields?.list?.length) {
      return item.fields.list || [];
    }

    return defaultContent;
  };

  const [getItemContentIndex, setGetItemContentIndex] = useState(0);

  const handleBrandSelect = (index) => {
    setGetItemContentIndex(index);
  };

  return (
    <div className="CarDetailsChangeComp">
      <section
        className="CarDetailsChange__title"
        dangerouslySetInnerHTML={{ __html: fields.title?.value }}
      ></section>

      <section
        className="CarDetailsChange__remarks"
        dangerouslySetInnerHTML={{ __html: fields.remarks?.value }}
      ></section>

      <div className="CarDetailsChange__tagOut">
        <div className="CarDetailsChange__tagContent">
          {fields?.list?.length
            ? fields.list.map((val, e) => {
                return (
                  <div
                    className={`${'CarDetailsChange__tag'} ${
                      e === getItemContentIndex ? 'selected' : ''
                    }`}
                    key={e}
                    onClick={() => handleBrandSelect(e)}
                  >
                    {getItemTitle(val)}
                  </div>
                );
              })
            : ''}
        </div>
      </div>

      <section className="CarDetailsChange__details">
        {fields?.list?.length
          ? getItemContent(fields.list[getItemContentIndex]).map((val, e) => {
              return (
                <div className="CarDetailsChange__detailsItem" key={e}>
                  <em>{val.fields?.title?.value}</em>
                  <p>{val.fields?.remarks?.value}</p>
                </div>
              );
            })
          : ''}
      </section>
    </div>
  );
}
